// ScrollContainer.js - 基类组件
import React from 'react';
import { withRouter } from 'react-router-dom'
import { universitiesList } from './Universities'
import LazyImage from './components/lazyImage.jsx';
import Header from './components/header.jsx';
import Footer from './components/footer.jsx';



class Upm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentTab: 0
        };


    }

    componentDidMount() {



    }

    onToggleTab = (value) => {
        this.setState({ currentTab: value })


    }


    render() {

        return (
            <div className={`flex-col`}>
                <Header activeMenu='1' />
                <div className='dv_vpm_body'>
                    <div className={`flex-col dv_vpm_main_body`}>
                        <div className='dv_banner_wrap'><img src={require("./assets/img/convoy/55_000056.jpg")} /></div>
                        <div className='dv_vpm_content_wrap'>
                            <div className='dv_trake_change flex-row between'>
                                <div className={this.state.currentTab == 0 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(0)}>教育部SQA项目</div>
                                <div className={this.state.currentTab == 1 ? 'tab selected' : 'tab clickable'} onClick={() => this.onToggleTab(1)}>国外合作院校</div>
                            </div>
                            {this.state.currentTab == 0 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000057.jpg")} />

                            </div>}
                            {this.state.currentTab == 1 && <div>
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000071.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000072.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000073.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000074.jpg")} />
                                <LazyImage imgUrl={require("./assets/img/convoy/55_000075.jpg")} />
                            </div>}

                        </div>
                    </div>


                </div>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Upm);